import articleCJUE2025 from './cjue-2025-reparation-pratiques-anticoncurrentielles';
import articleGoogleAmende from './google-amende-2-95-milliards-risques-secteur';
import articleIFRS18 from './ifrs-18-preparer-etats-financiers-2027';
import articleIFRS2025 from './ifrs-2025-amendements-ias21-ifrs7';
import articleLoiFinances2026 from './loi-finances-2026-mesures-fiscales';
import articleBudget2026 from './budget-2026-mesures-adoptees-strategies';
import articleBarometre2025 from './barometre-2025-transformation-digitale-pme';
import articleTransformationLevier from './transformation-digitale-levier-croissance';
import articleMesurerGains from './mesurer-gains-transformation-digitale';
import articleWebinaire2026 from './webinaire-transformation-digitale-2026';

export const newsArticles = [
  articleCJUE2025,
  articleGoogleAmende,
  articleIFRS18,
  articleIFRS2025,
  articleLoiFinances2026,
  articleBudget2026,
  articleBarometre2025,
  articleTransformationLevier,
  articleMesurerGains,
  articleWebinaire2026
];